// Wrapper to expose SpaceFeed for reuse without moving large code blocks
import { SpaceFeed } from '../pages/ConversationsPage.jsx';
export default SpaceFeed;
export { SpaceFeed };
